// extracted by mini-css-extract-plugin
export var container = "_nu-0";
export var dotAnimation = "_nu-2";
export var dotsLoading = "_nu-1";